import { BetHistoryTypes } from "actions/types";
import axios from "axios";
import { fromJS, List, OrderedMap } from "immutable";
import { serverError } from "actions/error";
import * as queryString from "query-string";

export function fetchBetHistoryFilter(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_BET_HISTORY_FILTER,
      payload: {
        route,
        method,
        headers,
        url,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    }).then(({ data }) => {
      return fromJS(data);
    });
  };
}

export function setBetHistoryFilter(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_BET_HISTORY_FILTER,
      payload,
    });
  };
}

export function showBetHistory() {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SHOW_BET_HISTORY,
      payload: true,
    });
    return true;
  };
}

export function hideBetHistory() {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.HIDE_BET_HISTORY,
      payload: false,
    });
    return false;
  };
}

export function fetchHistoryBalance(route) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_HISTORY_BALANCE,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
      },
    });

    return axios({
      method,
      headers,
      url,
    }).then(({ data }) => {
      return fromJS(data);
    });
  };
}

export function setHistoryBalance(data) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_HISTORY_BALANCE,
      payload: data,
    });
    return data;
  };
}

export function fetchBetHistoryUrl() {
  return (dispatch, getState) => {
    let route = getState()
      .profile.get("links")
      .find((link) => {
        return link.get("rel") === "service.url";
      });
    try {
      var host = getState().config.get("host");
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${host}${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }
    dispatch({
      type: BetHistoryTypes.FETCH_BET_HISTORY_URL,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
      },
    });
    return axios({
      method,
      headers,
      url,
    })
      .then(({ data }) => {
        dispatch({
          type: BetHistoryTypes.SET_BET_HISTORY_URL,
          payload: {
            url: data.url,
          },
        });
        return data;
      })
      .catch((error) => {
        dispatch(serverError(error));
        throw error;
      });
  };
}

export function fetchGameRoundHistoryLinks(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_HISTORY_LINKS,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setGameRoundHistoryLinks(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_HISTORY_LINKS,
      payload: payload,
    });
    return payload;
  };
}

export function fetchGameRoundHistory(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_GAME_ROUND_HISTORY,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        //to fix immubtale object sorting
        let newData = OrderedMap(data);
        let newList = List([]);
        for (let i = 0; i < data.items.length; i++) {
          let item = data.items[i];

          let newLinks = List([]);

          if (item.links) {
            for (let j = 0; j < item.links.length; j++) {
              let itemObj = OrderedMap(item.links[j]);
              newLinks = newLinks.push(itemObj);
            }
            item.links = newLinks;
          }

          if (item.game) {
            item.game = OrderedMap(item.game);
          }
          if (item.claimedGame) {
            item.claimedGame = OrderedMap(item.claimedGame);
          }
          if (item.totalBet) {
            item.totalBet = OrderedMap(item.totalBet);
          }

          newList = newList.push(OrderedMap(item));
        }
        newData = newData.setIn(["items"], newList);
        return newData;
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setGameRoundHistory(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_GAME_ROUND_HISTORY,
      payload: payload,
    });
    return payload;
  };
}

export function fetchGameHistoryAvailableMonths(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_GAME_HISTORY_AVAILABLE_MONTHS,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setGameHistoryAvailableMonths(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_GAME_HISTORY_AVAILABLE_MONTHS,
      payload: payload,
    });
    return payload;
  };
}

export function fetchWalletTransactionsAvailableReferenceTypes(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setWalletTransactionsAvailableReferenceTypes(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES,
      payload: payload,
    });
    return payload;
  };
}

export function fetchWalletTransactionsAvailableMonths(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_WALLET_TRANSACTION_AVAILABLE_MONTHS,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setWalletTransactionsAvailableMonths(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_WALLET_TRANSACTION_AVAILABLE_MONTHS,
      payload: payload,
    });
    return payload;
  };
}

export function fetchWalletTransaction(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_WALLER_TRANSACTIONS,
      payload: {
        headers,
        route,
        params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setWalletTransactions(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_WALLER_TRANSACTIONS,
      payload: payload,
    });
    return payload;
  };
}

export function fetchGameRoundHistoryPerGameRoute(route) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_GAME_ROUND_HISTORY_PER_GAME_ROUTE,
      payload: {
        headers,
        route,
      },
    });

    return axios({
      method,
      headers,
      url,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function fetchGameRoundHistoryPerGame(route, params) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var rawUrl = route.get("href");
      var method = route.get("method");
      var [baseUrl, query] = rawUrl.split("?");
      var existingQuery = queryString.parse(query || "");
      var mergedParams = {
        ...existingQuery,
        ...params,
      };

      dispatch({
        type: BetHistoryTypes.FETCH_GAME_ROUND_HISTORY_PER_GAME,
        payload: {
          headers,
          route,
          params: mergedParams,
        },
      });

      return axios({
        method,
        headers,
        url: baseUrl,
        params: mergedParams,
      })
        .then(({ data }) => {
          //insert here!!!
          //to fix immubtale object sorting
          let newData = OrderedMap(data);
          let newList = List([]);
          for (let i = 0; i < data.items.length; i++) {
            let item = data.items[i];

            let newLinks = List([]);

            for (let j = 0; j < item.links.length; j++) {
              let itemObj = OrderedMap(item.links[j]);
              newLinks = newLinks.push(itemObj);
            }
            item.links = newLinks;
            newList = newList.push(OrderedMap(item));
          }
          newData = newData.setIn(["items"], newList);
          return newData;
        })
        .catch((err) => {
          throw err;
        });
    } catch (error) {
      throw error;
    }
  };
}

export function setGameRoundHistoryPerGameRoute(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_GAME_ROUND_HISTORY_PER_GAME_ROUTE,
      payload: payload,
    });
    return payload;
  };
}

export function setGameRoundHistoryPerGame(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_GAME_ROUND_HISTORY_PER_GAME,
      payload: payload,
    });
    return payload;
  };
}

export function fetchGameRounds(route) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var url = route.get("href");
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: BetHistoryTypes.FETCH_GAME_ROUNDS,
      payload: {
        headers,
        route,
      },
    });

    return axios({
      method,
      headers,
      url,
    })
      .then(({ data }) => {
        return fromJS(data);
      })
      .catch((err) => {
        throw err;
      });
  };
}

export function setGameRounds(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: BetHistoryTypes.SET_GAME_ROUNDS,
      payload: payload,
    });
    return payload;
  };
}

export function fetchBetHistory(route, params) {
  return (dispatch, getState) => {
    try {
      var host = getState().config.get("host");
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${host}${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }
    dispatch({
      type: BetHistoryTypes.SET_GAME_ROUNDS,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
        params: params,
      },
    });

    return axios({
      method,
      headers,
      url,
      params,
    })
      .then(({ data }) => {
        /* switch(params.page) {
        case 1:
          data = data1;
          break;
        case 2:
          data = data2;
          break;
        case 3:
          data = data3;
          break;
        case 4:
          data = data4;
          break;
        default:
          break;
      } */

        return dispatch(
          setBetHistroy(
            fromJS(
              Object.assign({
                route,
                data,
              })
            )
          )
        );
      })
      .catch((error) => {
        dispatch({
          type: BetHistoryTypes.ERROR_FETCH_BET_HISTORY,
          payload: error,
        });
        throw error;
      });

    //return
  };
}

export function setBetHistroy(payload) {
  return {
    type: BetHistoryTypes.SET_BET_HISTORY,
    payload: payload,
  };
}

export function clearBetHistory() {
  return {
    type: BetHistoryTypes.CLEAR_BET_HISTORY,
  };
}
